import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { InfoGridComponent } from '@3ddv/software-division-components/backoffice/info-grid';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../../../core/services/loader.service';
import { DialogCloseReason } from '../../../layout/dialog/app-dialog.service';
import { RedisRecord } from '../../models/redis-manager.model';
import { RedisManagerService } from '../../services/redis-manager.service';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrl: './delete.component.css',
  imports: [BoDialogComponent, ButtonComponent, InfoGridComponent],
})
export class DeleteComponent implements OnInit, OnDestroy {
  private dialogRef = inject<BrnDialogRef<DialogCloseReason>>(BrnDialogRef);
  private redisManagerService = inject(RedisManagerService);
  private loader = inject(LoaderService);
  private toastrService = inject(ToastrService);

  readonly key = input.required<string>();

  public data: RedisRecord;
  private subscriptions: Array<Subscription>;
  private waitingApi: boolean;
  constructor() {
    this.subscriptions = [];
    this.waitingApi = false;
  }

  get json() {
    if (!this.data) {
      return '';
    }
    let json = null;

    try {
      json = JSON.parse(this.data?.value);
    } catch (error) {
      json = this.data?.value;
    }

    return JSON.stringify(json, undefined, 2);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  ngOnInit(): void {
    const key = this.key();
    const g$ = this.loader.track(this.redisManagerService.get$(key)).subscribe({
      next: response => {
        this.data = response.data;
      },
      error: () => {
        this.toastrService.error(
          `An error occurred trying to get the redis key: ${key}`,
          'Error'
        );
      },
    });
    this.subscriptions.push(g$);
  }

  public onDismiss(reason: DialogCloseReason) {
    this.dialogRef.close(reason);
  }

  public onConfirm(key: string) {
    if (this.waitingApi) return;
    this.waitingApi = true;

    this.redisManagerService.delete$(key).subscribe({
      next: () => {
        this.onDismiss('success');
      },
      error: () => {
        this.toastrService.error(
          `An error occurred trying to delete the redis key: ${key}`,
          'Error'
        );
      },
    });
  }
}
